import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import img1 from '../../images/bar/bar-carousel-1.png';
import img2 from '../../images/bar/bar-carousel-2.png';
import img3 from '../../images/bar/bar-carousel-3.png';


const BarCarousel = () => {
  return (
    <Carousel style={{ "maxHeight": "500px" }}>
        <Carousel.Item>
            <img
                className="d-block w-100"
                src={img1}
                alt="First slide"
            />
            <Carousel.Caption>
                <h3 style={{color: 'white'}}>Exiquisite!!</h3>
                <p>We have an exiquisite range of wines and whiskeys.</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
                className="d-block w-100"
                src={img2}
                alt="Second slide"
            />
            <Carousel.Caption>
                <h3 style={{color: 'white'}}>Exiquisite!!</h3>
                <p>We have an exiquisite range of wines and whiskeys.</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
                className="d-block w-100"
                src={img3}
                alt="Third slide"
            />
            <Carousel.Caption>
                <h3 style={{color: 'white'}}>Exiquisite!!</h3>
                <p>We have an exiquisite range of wines and whiskeys.</p>
            </Carousel.Caption>
        </Carousel.Item>
    </Carousel>
  )
}

export default BarCarousel;